import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bookDemo } from '../../redux/thunks/bookDemo';
import { Empty, Form, Input, Modal } from 'antd';
import { showAlert } from '../../utils/helpers/toastify';
import { toastTheme, toastType, homePageMessage } from '../../constants/app.constants';
import { bookDemoActionTypes } from '../../redux/actionTypes';
import { Select } from 'antd';
import parsePhoneNumber, { isValidPhoneNumber } from 'libphonenumber-js';
import styles from './requestDemo.module.scss';
import { useForm } from 'antd/lib/form/Form';
const countries = require('country-codes-list');


const RequestDemo = ({ open, onClose, maskClosable=true, }) => {
  const [alertMessage, setAlertMessage] = useState('');

  const [form] = Form.useForm();
  const [details, setDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    countryCode: '',
    companyName: '',
    message: '',
  });
  const dispatch = useDispatch();
  const { error, loading, bookDemo: bookDemoData } = useSelector((state) => state.bookDemo);
  
  const onChangeHandler = (e, type) => {
    if (type == 'firstName') {
      setDetails({ ...details, firstName: e.target.value });
    }
    if (type == 'lastName') {
      setDetails({ ...details, lastName: e.target.value });
    }
    if (type == 'email') {
      setDetails({ ...details, email: e.target.value });
    }
    if (type == 'phoneNumber') {
      setDetails({ ...details, phoneNumber: e.target.value });
    }
    if (type == 'countryCode') {
      setDetails({ ...details, countryCode: e });
    }
    if (type == 'companyName') {
      setDetails({ ...details, companyName: e.target.value });
    }
    if (type == 'message') {
      setDetails({ ...details, message: e.target.value });
    }
  };

  const filterOption = (input, option) =>
    (option?.value ?? '').toLowerCase().includes(input.toLowerCase());

  const onSubmitHandler = () => {
    dispatch(
      bookDemo({
        details: details,
        onSuccess:onClose(),
      })
    );
  };

  useEffect(() => {
    if (alertMessage && alertMessage.type && alertMessage.message) {
      showAlert({
        type: alertMessage.type,
        message: alertMessage.message,
        autoClose: 5000,
      });
      removeAlert();
    }
  }, [alertMessage]);

  const removeAlert = () => {
    setAlertMessage('');
    if (error || bookDemoData.message)
      dispatch({ type: bookDemoActionTypes.REMOVE_BOOKDEMO_POPUP });
  };

  useEffect(() => {
    if (error) {
      setAlertMessage({ type: toastType.error, message: error });
    }
    if (bookDemoData.message) {
      setAlertMessage({ type: toastType.info, message: bookDemoData.message });
    }
    return () => {};
  }, [error, bookDemoData.message]);

  let countryCode = Object.values(
    countries.customList('countryCode', '+{countryCallingCode}')
  ).sort();

  countryCode = countryCode
    .filter((item, index) => countryCode.indexOf(item) === index)
    .map((code) => {
      return { value: code };
    });
  
  const prefixSelector = (
    <Form.Item
      name="countryCode"
      noStyle
      rules={[
        {
          required: true,
          message: 'Please input Country Code!',
        },
      ]}
    >
      <Select
        className={styles.countryCode}
        style={{
          width: 70,
        }}
        notFoundContent={
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        }
        showSearch
        autoComplete="none"
        listHeight={250}
        listItemHeight={10}
        filterOption={filterOption}
        getPopupContainer={(trigger) => trigger.parentElement}
        onChange={(e) => onChangeHandler(e, 'countryCode')}
        options={countryCode}
      ></Select>
    </Form.Item>
  );

  useEffect(()=>{
    setDetails({
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      countryCode: '',
      companyName: '',
      message: '',
    }) 
    form.resetFields();
  },[open])
  return (
    <Modal 
      visible={open}
      footer={null}
      header={null}
      title={'Request Demo'}
      className={styles.requestDemoModal}
      onCancel={onClose}
      maskClosable={maskClosable}
      destroyOnClose
      getContainer={false}
    >
      <div className={styles.bookdemoForm}>
        <p>
          We are always looking for new ways to innovate and partner with others. If you are
          interested in learning more about our services or collaborating with us on a new project,
          please leave your information below. We would love to hear from you!
        </p>
        <Form form={form} onFinish={onSubmitHandler}>
          <div className={styles.formItem}>
            <Form.Item
              name="firstName"
              rules={[
                {
                  required: true,
                  message: 'Please input First Name!',
                },
                {
                  pattern: /^[A-Za-z]+$/,
                  message: 'Name can only include letters!',
                },
                {
                  min: 2,
                  max: 15,
                  message: 'Name must be in range 2-15!',
                },
              ]}
              style={{ marginBottom: '13px' }}
            >
              <input
                placeholder="First Name"
                onChange={(e) => onChangeHandler(e, 'firstName')}
              ></input>
            </Form.Item>
            <Form.Item
              name="lastName"
              rules={[
                {
                  required: true,
                  message: 'Please input Last Name!',
                },
                {
                  pattern: /^[A-Za-z]+$/,
                  message: 'Name can only include letters!',
                },
                {
                  min: 2,
                  max: 15,
                  message: 'Name must be in range 2-15!',
                },
              ]}
              style={{ marginBottom: '13px' }}
            >
              <input
                placeholder="Last Name"
                onChange={(e) => onChangeHandler(e, 'lastName')}
              ></input>
            </Form.Item>
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: homePageMessage.inputEmail,
                },
                {
                  type: 'email',
                  message: homePageMessage.inputValidEmail,
                },
              ]}
              style={{ marginBottom: '13px' }}
            >
              <input
                placeholder="Business Email"
                onChange={(e) => onChangeHandler(e, 'email')}
              ></input>
            </Form.Item>
            <Form.Item
              name="phone"
              rules={[
                () => ({
                  validator(_, value) {
                    const validator = parsePhoneNumber(details.countryCode + details.phoneNumber);
                    if (details.phoneNumber.length == 0) {
                      return Promise.reject('Please input your phone number!');
                    }
                    if (!validator?.isValid()) {
                      return Promise.reject('Please enter a valid phone number!');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              style={{ marginBottom: '13px' }}
              className={styles.phoneNumber}
            >
              <Input
                addonBefore={prefixSelector}
                placeholder="Enter Phone Number"
                style={{
                  width: '100%',
                  maxWidth: '250px',
                }}
                onChange={(e) => onChangeHandler(e, 'phoneNumber')}
                disabled={!details.countryCode}
              />
            </Form.Item>
            <Form.Item
              name="companyName"
              rules={[
                {
                  required: true,
                  message: 'Please input Company Name!',
                },
                {
                  pattern: /^[a-zA-Z\d\s]+$/,
                  message: 'Company name can only include letters and digits!',
                },
                {
                  pattern: /^(?!.*(?<! ) {2,}(?! ))/,
                  message: 'More than one consecutive space is not allowed!',
                },
                {
                  min: 2,
                  max: 50,
                  message: 'Company name must be in range 2-50!',
                },
              ]}
              style={{ marginBottom: '13px' }}
            >
              <input
                placeholder="Company Name"
                onChange={(e) => onChangeHandler(e, 'companyName')}
              ></input>
            </Form.Item>
          </div>
          <Form.Item
            name="message"
            rules={[
              {
                required: true,
                message: 'Please input Message!',
              },
              {
                max: 199,
                message: 'Message limit is of 200 letters!',
              },
              {
                pattern: /^(?!.*(?<! ) {2,}(?! ))/,
                message: 'More than one consecutive space is not allowed!',
              },
            ]}
            style={{ marginBottom: '13px' }}
          >
            <textarea
              placeholder="Type Your Message Here"
              onChange={(e) => onChangeHandler(e, 'message')}
            ></textarea>
          </Form.Item>
          <Form.Item className={styles.btn} style={{ marginBottom: '0' }}>
            <button type="primary" htmlType="submit" style={{ marginTop: '5px' }}>
              SUBMIT
            </button>
            <button
              type="primary"
              onClick={onClose}
              style={{ marginTop: '5px' }}
            >
              CANCEL
            </button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default RequestDemo;
